import { useEffect, useState } from "react";
import constants from "../constants";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { accessTokenType } from "../modals/IloginCard";

export const AccessTokenDecoder = () => {
  const [accessToken, setAccessToken] = useState<string | null>(
    sessionStorage.getItem(constants.accessTokenText)
  );
  useEffect(() => {
    setAccessToken(sessionStorage.getItem(constants.accessTokenText));
  }, []);

  const decodeToken: accessTokenType = jwtDecode(accessToken || "");

  return decodeToken;
};

export const AsyncAccessTokenDecoder = () => {
  const [accessToken, setAccessToken] = useState<string | null>(
    sessionStorage.getItem(constants.accessTokenText)
  );
  useEffect(() => {
    setAccessToken(sessionStorage.getItem(constants.accessTokenText));
  }, []);

  let decodeToken: accessTokenType | null = null;
  if (accessToken) {
    try {
      decodeToken = jwtDecode(accessToken);
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }
  return decodeToken;
};



export interface CustomJwtPayload extends JwtPayload {
  Roles?: string;
  userId?: string | number;
  // add any other fields your token has
}

export const AsyncAccessTokenDecoder1 = async (): Promise<CustomJwtPayload | null> => {
  const accessToken = sessionStorage.getItem(constants.accessTokenText);
  if (!accessToken) return null;

  try {
    return jwtDecode<CustomJwtPayload>(accessToken);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const AccessTokenDecoder1 = (): CustomJwtPayload | null => {
  const accessToken = sessionStorage.getItem(constants.accessTokenText);
  if (!accessToken) return null;

  try {
    return jwtDecode<CustomJwtPayload>(accessToken);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const AccessTokenDecoderSync = (): CustomJwtPayload | null => {
  // debugger
  const token = sessionStorage.getItem(constants.accessTokenText);
  if (!token) return null;
  try {
    return jwtDecode<CustomJwtPayload>(token);
  } catch {
    return null;
  }
};